<ul
    *ngIf="categories"
    class="agpr-mie-interactive-list"
    [attr.aria-label]="'Briefings.mentionInsights.categoryList.ariaLabel' | localize"
>
    <li
        *ngFor="let category of categories"
        class="agpr-mie-interactive-list-category"
    >
        <label class="agpr-mie-interactive-list-category-label">
            {{ category.name | localize }}
        </label>
        <ul
            *ngIf="category.interactable"
            class="agpr-mie-interactive-list-category-entryList"
            [attr.aria-label]="category.name"
            agprListKeyboardNavigation
            [focusOnChild]="true"
        >
            <li *ngFor="let entry of category.entries">
                <div
                    role="button"
                    class="agpr-mie-interactive-list-category-entry"
                    [ngClass]="{'agpr-mie-interactive-list-category-entry--disabled': isAiGenerating}"
                    tabindex="0"
                    [attr.aria-expanded]="entry.expanded"
                    (keydown.enter)="toggle(category.name, entry, prompt)"
                    (keydown.space)="toggle(category.name, entry, prompt)"
                    (click)="toggle(category.name, entry, prompt)"
                >
                    <span
                        *ngIf="entry.generating"
                        class="agpr-mie-interactive-list-category-entry-spinner"
                        [agprLoading]="entry.generating"
                        [loadingSmallIndicator]="entry.generating"
                    ></span>
                    <span
                        *ngIf="!entry.generating"
                        role="img"
                        class="agpr-mie-interactive-list-category-entry-toggleButton"
                        [ngClass]="entry.expanded ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'"
                        aria-hidden="true"
                    ></span>
                    <span class="agpr-mie-interactive-list-category-entry-name">
                        {{entry.name}}
                    </span>
                </div>
                <p
                    class="agpr-mie-interactive-list-category-entry-insight"
                    [@insightState]="entry.expanded ? 'visible' : 'hidden'"
                    [innerHTML]="entry.insight"
                ></p>
            </li>
        </ul>

        <div *ngIf="!category.interactable">
            <ng-container *ngFor="let entry of category.entries; let last = last">{{ entry.name }}{{ last ? '' : ', ' }}</ng-container>
        </div>
    </li>
</ul>

<div
    *ngIf="!prompt.insightModel && prompt.insightText"
    [innerHTML]="prompt.insightText"
></div>